(function () {
  'use strict';
  if (window.ShoeMedicLeadAnalytics) return;

  function enqueue(name, parameters) {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
        typeof privacy.saleOfDataAllowed !== 'function') return 'privacy-api-unavailable';
    if (privacy.analyticsProcessingAllowed() !== true) return 'analytics-consent-denied';
    if (privacy.saleOfDataAllowed() !== true) return 'data-sale-consent-denied';
    if (location.protocol !== 'https:' || location.hostname !== 'shoemedic.com') return 'invalid-location';
    window.dataLayer = window.dataLayer || [];
    if (typeof window.dataLayer.push !== 'function') return 'google-queue-unavailable';
    const payload = Object.assign({
      send_to: 'G-86LD395ZX7',
      page_location: location.origin + location.pathname,
      page_referrer: '',
      allow_google_signals: false,
      allow_ad_personalization_signals: false
    }, parameters);
    try {
      (function () { window.dataLayer.push(arguments); }('event', name, payload));
      return 'queued';
    } catch (_) { return 'google-queue-unavailable'; }
  }

  function formSuccess(formId) {
    if (formId === 'general_enquiry') {
      return enqueue('contact_form_submission', {
        form_id: formId, form_name: 'general_enquiry', lead_type: 'general_enquiry'
      });
    }
    if (formId === '163971' || formId === '161961' || formId === '167195') {
      return enqueue('contact_form_submission', {
        form_id: formId, form_name: 'repair_assessment', lead_type: 'repair_assessment'
      });
    }
    return 'invalid-form';
  }

  window.ShoeMedicLeadAnalytics = Object.freeze({formSuccess: formSuccess});
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !event.target || typeof event.target.closest !== 'function') return;
    const link = event.target.closest('a[href]');
    const href = link && link.getAttribute('href');
    if (typeof href !== 'string' || !/^tel:\+?14168700000$/i.test(href.replace(/[\s()-]/g, ''))) return;
    enqueue('Phone_number_Click', {contact_method: 'phone'});
  }, true);

  if (window.Shopify && !Shopify.customerPrivacy && typeof Shopify.loadFeatures === 'function') {
    Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function () {});
  }
}());
